import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { CadastreSolaireInfoModalComponent } from '../../../../modals/info/cadastre-solaire-info-modal.component';

import { LocalStorageService } from 'src/app/services/local-storage.service';
import { SolarPvSurplusService } from 'src/app/services/cadastre-solaire/cadastre-solaire-pv-surplus.service';
import { SolarService } from 'src/app/services/cadastre-solaire/cadastre-solaire.service';
import { UsefulService } from 'src/app/services/UsefulService';
import { SolarThermalService } from 'src/app/services/cadastre-solaire/cadastre-solaire-thermal.service';
import { IncomeBracket, ProfileEnum } from 'src/app/models/Solar';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'cadastreSolaireThermalBuidingDescription',
    templateUrl: './cadastre-solaire-building-description.template.html',
    styleUrls: ['./cadastre-solaire-building-description.component.scss'],
    standalone: false,
})
export class CadastreSolaireThermalBuildingDescriptionComponent implements OnInit {
    public showMobileUi: boolean = false;

    public modularity: any;

    public formGroup: FormGroup;
    public isFormValid: boolean = false;

    public shouldAddIncomeBracket: boolean = false;
    public incomeBracketOptions = Object.entries(IncomeBracket).map(([key, value]) => ({
        label: value,
        value: key,
    }));

    constructor(
        private readonly formBuilder: FormBuilder,
        private modalService: NgbModal,
        @Inject(LocalStorageService) private localStorageService: LocalStorageService,
        @Inject(SolarService) public solarService: SolarService,
        @Inject(SolarThermalService) public solarThermalService: SolarThermalService,
        @Inject(UsefulService) private usefulService: UsefulService,
    ) {
        this.modularity = this.localStorageService.get('preferences').modularity.solar;
        const profile = this.solarService.getProfile();

        const defaultOccupantCount = this.solarThermalService.occupantCount;
        this.formGroup = this.formBuilder.group({
            occupantCount: [defaultOccupantCount, [Validators.required, Validators.min(1)]],
        });

        this.shouldAddIncomeBracket =
            profile === ProfileEnum.INDIVIDUAL && environment.isLomiaIncomeBracketsDefined;

        if (this.shouldAddIncomeBracket) {
            const defaultIncomeBracket = this.solarThermalService.incomeBracket;
            this.formGroup.addControl(
                'incomeBracket',
                this.formBuilder.control(defaultIncomeBracket, Validators.required),
            );
        }
    }

    ngOnInit(): void {
        this.showMobileUi = this.usefulService.showMobileUi;
        this.modularity = this.localStorageService.get('preferences').modularity.solar;

        // if (this.solarPvSurplusService.equipmentsData.usableFloorArea == null) {
        //     this.solarPvSurplusService.equipmentsData.usableFloorArea =
        //         this.solarPvSurplusService.setDefaultUsableFloorArea();
        //     this.solarPvSurplusService.equipmentsData.occupantCount =
        //         this.solarPvSurplusService.setDefaultOccupantCount();
        // }

        // const defaultOccupantCount = this.solarPvSurplusService.equipmentsData.occupantCount;

        this.checkFormValidity();
        this.formGroup.valueChanges.subscribe((values) => this.checkFormValidity());
    }

    get occupantCountControl() {
        return this.formGroup.get('occupantCount');
    }

    get incomeBracketControl() {
        return this.formGroup.get('incomeBracket');
    }

    public cancel() {
        this.solarService.updateMainStage('technologyStage');
    }

    public validate() {
        const occupantCountCtrl = this.formGroup.get('occupantCount');
        this.solarThermalService.setOccupantCount(Number(occupantCountCtrl!.value));

        if (this.shouldAddIncomeBracket) {
            const incomeBracketCtrl = this.formGroup.get('incomeBracket');
            this.solarThermalService.setIncomeBracket(incomeBracketCtrl!.value);
        }

        // const isDifferentOccupantCount =
        //     Number(occupantCountCtrl?.value) !=
        //     this.solarPvSurplusService.equipmentsData.occupantCount;

        // if (isDifferentOccupantCount) {
        //     this.solarPvSurplusService.equipmentsData.occupantCount = Number(
        //         occupantCountCtrl.value,
        //     );
        // }

        this.solarService.updateThermalStage('thermalSimulationStage');
    }

    public checkFormValidity() {
        this.isFormValid = this.formGroup.status === 'VALID';
    }

    public openIncomeInfoModal() {
        const title = `Tranche de revenus`;
        const body = `
            <div class="mb-3">
                <p>
                    Pour estimer le montant des aides à l’installation de panneaux solaire thermique auxquelles vous pouvez prétendre, il est nécessaire de s’appuyer sur les barèmes de revenus définis par l’Agence nationale de l'habitat (Anah). 
                </p>
                <p>
                    Sélectionner la tranche correspondante à votre catégorie de revenus permet d’établir une estimation plus précise des dispositifs applicables.
                </p>
                <p class="mb-0">
                    L’information relative à la tranche de revenus :
                </p>
                <ul class="mb-0">
                    <li>
                        est utilisée uniquement pour le calcul immédiat de l’estimation ;
                    </li>
                    <li>
                        n’est ni enregistrée, ni conservée, ni transmise ;
                    </li>
                    <li>
                        ne donne lieu à aucun contrôle ni demande de justificatif
                    </li>
                </ul>
                <p class="mb-0">
                    Si l’option « Ne souhaite pas répondre » est sélectionnée, le calcul sera réalisé sur la base d’une hypothèse standard.
                </p>
            </div>

            <div>
                <img 
                    src="../../../assets/img/cadastre-solaire/mayotte_aide_revenus.png" 
                    alt="mayotte_aide_revenus" 
                    height="250"
                >
                <div class="fs-7 text-end">
                    barème des plafonds de ressources de l’Anah
                </div>
            </div>

            
            `;

        this.modalService.dismissAll();
        const modalRef = this.modalService.open(CadastreSolaireInfoModalComponent, { size: 'xs' });
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.body = body;
    }
}
